import { mobile } from "../../../mediaQueries";
import mainBg from "../images/main-bg.png";

const styles = (theme) => ({
  bg: {
    minHeight: "700px",
    background: `url(${mainBg})`,
    backgroundRepeat: "no-repeat",
    display: "flex",
    height: "100vh",
    position: "relative",
    alignItems: "center",
    justifyContent: "center",
    backgroundSize: "cover",
    "@media (max-height: 550px)": {
      paddingBottom: "250px",
    },
  },
  video: {
    position: "absolute",
    right: 0,
    bottom: 0,
    backgroundSize: "cover",
    overflow: "hidden",
    minHeight: "100%",
    minWidth: "100%",
  },
  root: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "100px",
    zIndex: 1,
  },
  span: {
    cursor: "none !important",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    position: "absolute",
    bottom: "0",
    width: "100%",
  },
  wrapper: {
    cursor: "none !important",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    marginBottom: "-80px",
    [theme.breakpoints.down(theme.breakpoints.values.xs + mobile)]: {
      marginBottom: 0,
    },
  },
  arrow: {
    cursor: "pointer",
    zIndex: 90,
  },
  p: {
    cursor: "none !important",
    fontFamily: "Aktiv Grotesk",
    color: "white",
    fontSize: "1rem",
    letterSpacing: "0.04em",
    margin: "10px",
    textDecoration: "none",

    [theme.breakpoints.down(theme.breakpoints.values.xs + mobile)]: {
      fontSize: ".9rem",
    },
  },
  fade: {
    background:
      "linear-gradient(180deg, #FFFFFF 0%, rgba(196, 196, 196, 0) 100%);",
    height: "120px",
    transform: "rotate(-180deg)",
    width: "100%",
  },
});

export default styles;
